// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3dbb3ffc","389":"4ac10313","453":"90240df5","732":"71ee9af1","977":"e2bfb998"}[chunkId] + ".chunk.js";
};